(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1037],{

/***/ 33479:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/your-offer-salary",
      function () {
        return __webpack_require__(54369);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* reexport */ FormCustomSelect; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/HashAnchor/index.ts + 2 modules
var HashAnchor = __webpack_require__(40176);
// EXTERNAL MODULE: ./components/shared/CustomSelect.tsx + 1 modules
var CustomSelect = __webpack_require__(88888);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ./components/form/FormCustomSelect/FormCustomSelect.tsx







var FormCustomSelect = function(param) {
    var name = param.name, options = param.options, _formGroup = param.formGroup, formGroup = _formGroup === void 0 ? {} : _formGroup, _input = param.input, input = _input === void 0 ? {} : _input, children = param.children;
    var ref, ref1;
    var ref2 = (0,index_esm/* useFormContext */.Gc)(), control = ref2.control, errors = ref2.formState.errors;
    var onChangeHandler = input.onChange || function() {
    // NOOP
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        error: errors === null || errors === void 0 ? void 0 : (ref = errors[name]) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1.toString(),
        forId: name
    }, formGroup), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                name: name,
                control: control,
                render: function(param) {
                    var field = param.field;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HashAnchor/* HashAnchor */.v, {
                                name: "anchor_".concat(name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                id: name,
                                options: options || []
                            }, input, field), {
                                onChange: function(e) {
                                    field.onChange(e);
                                    onChangeHandler(e);
                                }
                            }))
                        ]
                    });
                }
            }),
            children
        ]
    }));
};

;// CONCATENATED MODULE: ./components/form/FormCustomSelect/index.ts



/***/ }),

/***/ 83112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ StyledCheckboxLabel; },
/* harmony export */   "P2": function() { return /* binding */ StyledCheckbox; },
/* harmony export */   "_5": function() { return /* binding */ StyledCheckboxIcon; }
/* harmony export */ });
/* unused harmony export StyledCheckboxGroup */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-shrink: 0;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  margin-right: ",
        ";\n  position: relative;\n  transition: 0.3s;\n\n  &::after {\n    content: '';\n    transform: translate(-50%, -50%) rotate(-45deg);\n    outline: 1px solid transparent;\n    position: absolute;\n    top: 40%;\n    left: 50%;\n    width: 0.8em;\n    height: 0.4em;\n    border: 3px solid ",
        ";\n    border-top: none;\n    border-right: none;\n    border-radius: 2px;\n    background-color: transparent;\n    opacity: 0;\n    transition: 0.3s;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      input[type='checkbox'] {\n        & + label {\n          border: 1px solid ",
        ";\n          border-radius: ",
        ";\n          padding: ",
        ";\n          box-shadow: ",
        ";\n          cursor: pointer;\n\n          font-weight: ",
        ";\n        }\n\n        &:checked + label {\n          background: ",
        ";\n          border-color: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  input[type='checkbox'] {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n\n    &:checked + label ",
        " {\n      background-color: ",
        ";\n      border-color: ",
        ";\n\n      &::after {\n        opacity: 1;\n      }\n    }\n\n    &:hover + label ",
        " {\n      border-color: ",
        ";\n    }\n\n    &:checked:hover + label ",
        " {\n      border-color: ",
        ";\n      background-color: ",
        ";\n    }\n\n    &:focus + label ",
        " {\n      outline: 0;\n      border-color: ",
        ";\n      box-shadow: 0 0 0 4px ",
        ";\n    }\n\n    &[disabled] {\n      pointer-events: none;\n\n      & + label {\n        color: ",
        ";\n        pointer-events: none;\n\n        ",
        " {\n          border-color: ",
        ";\n          background-color: ",
        ";\n        }\n      }\n\n      &:checked + label ",
        " {\n        border-color: ",
        ";\n        background-color: ",
        ";\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  font-size: ",
        ";\n  line-height: 1;\n  vertical-align: text-bottom;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledCheckboxIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2515f10d-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledCheckboxGroup = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2515f10d-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"));
var StyledCheckbox = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2515f10d-2"
})(_templateObject3(), StyledCheckboxIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_800"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_800"), StyledCheckboxIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_400"), StyledCheckboxIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_600"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_600"), StyledCheckboxIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_850"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_disabled"), StyledCheckboxIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text-disabled"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), StyledCheckboxIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), function(param) {
    var isCard = param.isCard;
    return isCard && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .shadow */ .AF)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("extraBold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"));
});
var StyledCheckboxLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-2515f10d-3"
})(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"));


/***/ }),

/***/ 68341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Checkbox_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83112);
/* harmony import */ var _FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17975);
/* harmony import */ var _TooltipMF__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83885);








var Checkbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var label = _param.label, id = _param.id, helpContent = _param.helpContent, _isCard = _param.isCard, isCard = _isCard === void 0 ? false : _isCard, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "label",
        "id",
        "helpContent",
        "isCard"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Checkbox_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledCheckbox */ .P2, {
        isCard: isCard,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                type: "checkbox",
                id: id
            }, rest), {
                ref: ref
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Checkbox_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledCheckboxLabel */ .BS, {
                htmlFor: id,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Checkbox_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledCheckboxIcon */ ._5, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: label
                    })
                ]
            }),
            helpContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TooltipMF__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                content: helpContent,
                direction: "down",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "#",
                    onClick: function(e) {
                        return e.preventDefault();
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledHelpIcon */ .Xq, {})
                })
            })
        ]
    });
});
Checkbox.displayName = "Checkbox";
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 88888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_CustomSelect; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/match-sorter/dist/match-sorter.esm.js
var match_sorter_esm = __webpack_require__(71741);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/index-4bd03571.esm.js + 1 modules
var index_4bd03571_esm = __webpack_require__(64990);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/react-select.esm.js
var react_select_esm = __webpack_require__(31776);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/Select-dbb12e54.esm.js
var Select_dbb12e54_esm = __webpack_require__(47931);
;// CONCATENATED MODULE: ./components/shared/CurstomSelect.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_CUSTOM_SELECT_MATCH_ORDER = true;

;// CONCATENATED MODULE: ./components/shared/CustomSelect.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 









var Menu = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4bd03571_esm.c.Menu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: props.children
    }));
};
var MultiValueSeparator = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4bd03571_esm.c.MultiValue, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: props.children
            })),
            props.multiValueSeparator ? props.selectProps.value.length - 1 > props.index && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "multi-value-separator",
                children: props.multiValueSeparator
            }) : ""
        ]
    });
};
var ClearIndicator = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4bd03571_esm.c.ClearIndicator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: pro_light_svg_icons/* faTimes */.NBC
        })
    }));
};
var CustomSelect = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var options = param.options, placeholder = param.placeholder, _isMulti = param.isMulti, isMulti = _isMulti === void 0 ? false : _isMulti, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall, id = param.id, styles = param.styles, defaultValue = param.defaultValue, _isTransparent = param.isTransparent, isTransparent = _isTransparent === void 0 ? false : _isTransparent, onChange = param.onChange, value = param.value, _matchOrder = param.matchOrder, matchOrder = _matchOrder === void 0 ? DEFAULT_CUSTOM_SELECT_MATCH_ORDER : _matchOrder, max = param.max, hideDropdownUntilSearch = param.hideDropdownUntilSearch, formatOptionLabel = param.formatOptionLabel, _variant = param.variant, variant = _variant === void 0 ? "normal" : _variant, _closeMenuOnSelect = param.closeMenuOnSelect, closeMenuOnSelect = _closeMenuOnSelect === void 0 ? true : _closeMenuOnSelect, _menuPosition = param.menuPosition, menuPosition = _menuPosition === void 0 ? "absolute" : _menuPosition, _matchFrom = param.matchFrom, matchFrom = _matchFrom === void 0 ? "any" : _matchFrom, multiValueSeparator = param.multiValueSeparator;
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    var _$ref = (0,react.useState)(options), currentOptions = _$ref[0], setCurrentOptions = _$ref[1];
    var _$ref1 = (0,react.useState)(false), menuIsOpen = _$ref1[0], setMenuIsOpen = _$ref1[1];
    var handleOnInputChange = function(newValue) {
        if (hideDropdownUntilSearch) {
            setMenuIsOpen(newValue.length > 0);
        }
        if (matchOrder) {
            setCurrentOptions((0,match_sorter_esm/* matchSorter */.Lu)(options, newValue, {
                keys: [
                    "label"
                ]
            }));
        }
    };
    var MultiValueWithSeparator = (0,react.useMemo)(// eslint-disable-next-line react/display-name
    function() {
        return function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiValueSeparator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                multiValueSeparator: multiValueSeparator
            }));
        };
    }, [
        multiValueSeparator
    ]);
    (0,react.useEffect)(function() {
        setCurrentOptions(options);
    }, [
        options
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "id",
        options: currentOptions,
        classNamePrefix: "mf-select",
        className: "mf-select ".concat(hideDropdownUntilSearch ? "mf-select-autocomplete" : "", " ").concat(isSmall ? "cs-sm" : "", " ").concat(isTransparent ? "cs-transparent" : "", "\n        ").concat(variant === "error" ? "cs-error" : ""),
        placeholder: placeholder,
        isMulti: isMulti,
        inputId: id,
        styles: styles,
        defaultValue: defaultValue,
        menuPortalTarget:  true ? document.querySelector("body") : 0,
        formatOptionLabel: formatOptionLabel ? function(val) {
            return formatOptionLabel(val.label);
        } : undefined,
        onChange: function(newValue, actionMeta) {
            // Prevent onChange from firing when removing items with backspace
            if (actionMeta.action === "pop-value") return;
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue, actionMeta);
        },
        noOptionsMessage: function() {
            return t("customSelect.noOptions");
        }
    }, !matchOrder && {
        filterOption: (0,Select_dbb12e54_esm.c)({
            ignoreAccents: true,
            ignoreCase: true,
            matchFrom: matchFrom,
            trim: true
        })
    }), {
        value: value,
        max: max,
        ref: ref,
        menuPosition: menuPosition,
        onInputChange: handleOnInputChange,
        closeMenuOnSelect: closeMenuOnSelect,
        menuIsOpen: hideDropdownUntilSearch ? menuIsOpen : undefined,
        components: hideDropdownUntilSearch ? {
            Menu: Menu,
            ClearIndicator: ClearIndicator,
            MultiValue: MultiValueWithSeparator,
            DropdownIndicator: function() {
                return null;
            },
            IndicatorSeparator: function() {
                return null;
            }
        } : {
            Menu: Menu,
            ClearIndicator: ClearIndicator,
            MultiValue: MultiValueWithSeparator
        }
    }));
});
CustomSelect.displayName = "CustomSelect";
/* harmony default export */ var shared_CustomSelect = (CustomSelect);


/***/ }),

/***/ 17975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": function() { return /* binding */ StyledFormGroupContent; },
/* harmony export */   "OQ": function() { return /* binding */ StyledFormGroupField; },
/* harmony export */   "S0": function() { return /* binding */ StyledFormGroupLabelExtra; },
/* harmony export */   "Xq": function() { return /* binding */ StyledHelpIcon; },
/* harmony export */   "Z2": function() { return /* binding */ StyledFormGroupLabelWrapper; },
/* harmony export */   "Zm": function() { return /* binding */ StyledBottomAction; },
/* harmony export */   "dS": function() { return /* binding */ StyledFormGroup; },
/* harmony export */   "fI": function() { return /* binding */ StyledFormGroupSuccess; },
/* harmony export */   "jN": function() { return /* binding */ StyledFormGroupError; },
/* harmony export */   "kI": function() { return /* binding */ StyledFormGroupLabel; },
/* harmony export */   "nX": function() { return /* binding */ StyledFormGroupSpinnerSlot; },
/* harmony export */   "qB": function() { return /* binding */ StyledHint; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Select_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34956);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -",
        ";\n  left: 0;\n  z-index: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      align-items: center;\n      gap: ",
        ";\n\n      ",
        " {\n        margin-bottom: 0;\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: 0;\n      }\n\n      input {\n        flex-grow: 1;\n        width: auto;\n      }\n\n      ",
        " {\n        display: flex;\n        align-items: center;\n        padding-top: ",
        ";\n        padding-bottom: ",
        ";\n      }\n\n      ",
        " {\n        width: auto;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n\n  &.muted {\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      gap: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M8 10.7097C7.50116 10.7097 7.09677 11.1141 7.09677 11.6129C7.09677 12.1117 7.50116 12.5161 8 12.5161C8.49884 12.5161 8.90323 12.1117 8.90323 11.6129C8.90323 11.1141 8.49884 10.7097 8 10.7097ZM8.24742 9.93548H7.73129C7.51752 9.93548 7.34419 9.76216 7.34419 9.54839V9.5361C7.34419 7.26697 9.84226 7.48387 9.84226 6.07132C9.84226 5.42564 9.26932 4.77419 7.98935 4.77419C7.04923 4.77419 6.56145 5.08545 6.07932 5.69974C5.95326 5.86039 5.72274 5.89313 5.55519 5.77639L5.13152 5.48123C4.95006 5.35481 4.91023 5.10152 5.04619 4.92713C5.7309 4.04884 6.54329 3.48387 7.98935 3.48387C9.6771 3.48387 11.1326 4.44358 11.1326 6.07132C11.1326 8.24597 8.63452 8.13097 8.63452 9.5361V9.54839C8.63452 9.76216 8.46119 9.93548 8.24742 9.93548ZM8 1.03226C11.8265 1.03226 14.9677 4.13145 14.9677 8C14.9677 11.8481 11.8513 14.9677 8 14.9677C4.15342 14.9677 1.03226 11.8528 1.03226 8C1.03226 4.15474 4.14845 1.03226 8 1.03226ZM8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0Z' fill='%2330ABD5' /%3E%3C/svg%3E\");\n  height: ",
        ";\n  width: ",
        ";\n  display: inline-block;\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  justify-content: flex-start;\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    margin-top: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    margin-top: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var StyledFormGroupLabelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"));
var StyledFormGroupSpinnerSlot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .zindex */ .Y0)("spinnerSlot"));
var StyledBottomAction = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledHint = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-3"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_subtle"));
var StyledFormGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-4"
})(_templateObject5(), function(param) {
    var inline = param.inline;
    return inline && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), StyledFormGroupLabelWrapper, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), StyledBottomAction, StyledFormGroupContent, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), components_shared_Select_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledSelect */ .Q);
});
var StyledFormGroupLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-5dc5d8fe-5"
})(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"));
var StyledFormGroupField = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-6"
})(_templateObject8(), function(param) {
    var withAppend = param.withAppend;
    return withAppend && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
});
var StyledFormGroupContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-7"
})(_templateObject9());
var StyledHelpIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-8"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"));
var StyledFormGroupLabelExtra = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-5dc5d8fe-9"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_500"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"));
var StyledFormGroupError = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-10"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("negative_500"));
var StyledFormGroupSuccess = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-11"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("positive_500"));


/***/ }),

/***/ 74993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9725);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39105);
/* harmony import */ var _FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17975);
/* harmony import */ var _HelpTooltip_HelpTooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73091);






var FormGroup = function(param) {
    var label = param.label, children = param.children, error = param.error, forId = param.forId, className = param.className, labelExtra = param.labelExtra, bottomAction = param.bottomAction, _isLabelMuted = param.isLabelMuted, isLabelMuted = _isLabelMuted === void 0 ? false : _isLabelMuted, _inline = param.inline, inline = _inline === void 0 ? false : _inline, style = param.style, success = param.success, helpContent = param.helpContent, _isLabelHidden = param.isLabelHidden, isLabelHidden = _isLabelHidden === void 0 ? false : _isLabelHidden, hint = param.hint, append = param.append, spinnerSlot = param.spinnerSlot;
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__/* .useI18n */ .Q)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroup */ .dS, {
        className: className,
        style: style,
        inline: inline,
        children: [
            (label || labelExtra) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabelWrapper */ .Z2, {
                className: "".concat(isLabelHidden ? "sr-only" : ""),
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabel */ .kI, {
                        htmlFor: forId,
                        className: "".concat(isLabelMuted ? "muted" : "", " ").concat(isLabelHidden ? "sr-only" : ""),
                        children: label
                    }),
                    helpContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HelpTooltip_HelpTooltip__WEBPACK_IMPORTED_MODULE_4__/* .HelpTooltip */ .k, {
                        message: helpContent
                    }),
                    labelExtra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabelExtra */ .S0, {
                        children: labelExtra
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupField */ .OQ, {
                withAppend: !!append,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupContent */ .Fo, {
                        children: children
                    }),
                    append
                ]
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledHint */ .qB, {
                children: hint
            }),
            bottomAction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledBottomAction */ .Zm, {
                children: bottomAction
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupError */ .jN, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faTimesCircle */ .nYk
                    }),
                    t(error)
                ]
            }),
            success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupSuccess */ .fI, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faCheckCircle */ .f8k
                    }),
                    success
                ]
            }),
            spinnerSlot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupSpinnerSlot */ .nX, {
                children: spinnerSlot
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormGroup);


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 73091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ HelpTooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17975);
/* harmony import */ var _TooltipMF__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83885);



var HelpTooltip = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TooltipMF__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        content: message,
        type: "full-content",
        direction: "up",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledHelpIcon */ .Xq, {})
    });
};


/***/ }),

/***/ 34956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ StyledSelect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-color: ",
        " !important;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: ",
        ";\n      font-size: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      opacity: 1;\n      pointer-events: none;\n      background-color: ",
        ";\n      border-color: ",
        ";\n      color: ",
        ";\n      background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730957H7.46171C7.94067 0.730957 8.18015 1.30948 7.84111 1.64852L4.38075 5.11158C4.17087 5.32146 3.82913 5.32146 3.61925 5.11158L0.158886 1.64852C-0.180154 1.30948 0.0593268 0.730957 0.538289 0.730957Z' fill='%23DEDCE4'/%3E%3C/svg%3E%0A\");\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  appearance: none;\n  min-width: ",
        ";\n  height: 3.5rem;\n  padding: 1rem 3.25rem 1rem 1.25rem;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  border: 2px solid ",
        ";\n  transition: 0.3s;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730988H7.46171C7.94067 0.730988 8.18015 1.30951 7.84111 1.64855L4.38075 5.11161C4.17087 5.32149 3.82913 5.32149 3.61925 5.11161L0.158886 1.64855C-0.180154 1.30951 0.0593268 0.730988 0.538289 0.730988Z' fill='%23353241'/%3E%3C/svg%3E%0A\");\n  background-repeat: no-repeat;\n  background-position: right ",
        " top 50%;\n  background-size: 0.65em auto;\n  background-color: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  &:focus {\n    outline: 0;\n    border-color: ",
        ";\n    box-shadow: 0 0 0 4px ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var roleVariants = {
    error: {
        borderColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("negative_700")
    }
};
var sizeVariants = {
    sm: {
        padding: "0.25rem 0.75rem",
        fontSize: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"),
        height: "2.5rem"
    }
};
var StyledSelect = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-8861b5b9-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl6"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("sans"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white"), function(param) {
    var variant = param.variant;
    return variant && roleVariants[variant] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), roleVariants[variant].borderColor);
}, function(param) {
    var sizes = param.sizes;
    return sizes && sizeVariants[sizes] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), sizeVariants[sizes].padding, sizeVariants[sizes].fontSize, sizeVariants[sizes].height);
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_400"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_850"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), function(param) {
    var disabled = param.disabled;
    return disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_disabled"));
});


/***/ }),

/***/ 54369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ your_offer_salary; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./components/HashAnchor/index.ts + 2 modules
var HashAnchor = __webpack_require__(40176);
// EXTERNAL MODULE: ./components/layout/Page.styled.tsx
var Page_styled = __webpack_require__(29242);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ../../node_modules/randomcolor/randomColor.js
var randomColor = __webpack_require__(52411);
var randomColor_default = /*#__PURE__*/__webpack_require__.n(randomColor);
;// CONCATENATED MODULE: ./utils/colors.ts

var getRandomColorBySeed = function(seed, highlightCriteria) {
    return (highlightCriteria === null || highlightCriteria === void 0 ? void 0 : highlightCriteria()) ? randomColor_default()({
        seed: seed,
        luminosity: "bright",
        format: "rgba",
        alpha: 0.5
    }) : randomColor_default()({
        seed: seed,
        luminosity: "light",
        format: "rgba",
        alpha: 0.15
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./features/public-your-offer-salary/cta/YourOfferSalaryCta.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #d7edf1;\n  padding: 4rem 1rem;\n\n  @media (min-width: ",
        ") {\n    padding: 4rem 0;\n  }\n\n  h2 {\n    margin-bottom: 3rem;\n  }\n\n  h3 {\n    margin: 0;\n  }\n\n  .blur {\n    filter: blur(6px);\n  }\n\n  .badgeList {\n    flex-direction: row;\n  }\n\n  .slick-dots {\n    position: relative;\n    top: -2rem !important;\n    display: none !important;\n\n    @media (min-width: ",
        ") {\n      display: block !important;\n    }\n  }\n\n  .slick-arrow {\n    display: block !important;\n\n    width: 30px;\n    height: 30px;\n    top: 30%;\n\n    &.slick-prev {\n      left: -15px;\n    }\n\n    &.slick-next {\n      right: -15px;\n    }\n\n    &:before {\n      font-size: 30px;\n      color: #35b7b2;\n    }\n\n    @media (min-width: ",
        ") {\n      display: none !important;\n    }\n  }\n\n  li.slick-active > button {\n    background: #dcb4e8 !important;\n    border-color: #dcb4e8 !important;\n  }\n\n  .card {\n    position: relative;\n    margin: 0;\n\n    @media (min-width: ",
        ") {\n      margin: 0 1rem;\n    }\n\n    strong {\n      min-width: 130px;\n    }\n\n    .like {\n      position: absolute;\n      top: 0.5rem;\n      right: 0.5rem;\n      padding: 0.35rem;\n      gap: 0;\n\n      > span > span {\n        display: none;\n      }\n\n      @media (min-width: ",
        ") {\n        gap: 0.5rem;\n        padding: 0.5rem;\n\n        > span > span {\n          display: inline-block;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 0.875rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11efe1dd-0"
})(_templateObject(), (0,theme/* screen */.sp)("xl"), (0,theme/* screen */.sp)("xl"), (0,theme/* screen */.sp)("xl"), (0,theme/* screen */.sp)("sm"), (0,theme/* screen */.sp)("md"));
var Location = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11efe1dd-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.palette.text.subtle;
});
var AvatarContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11efe1dd-2"
})(_templateObject2());
var YourOfferSalaryCtaStyles = {
    Root: Root,
    Location: Location,
    AvatarContainer: AvatarContainer
};

;// CONCATENATED MODULE: ./features/public-your-offer-salary/cta/YourOfferSalaryCta.tsx









var YourOfferSalaryCta = function(param) {
    var data = param.data;
    var t = (0,useI18n/* useI18n */.Q)("your-offer-salary").t;
    if (!data.hasEnoughManfredites || !data.stats || data.stats.manfredites.length <= 0) {
        return null;
    }
    var manfrediteNames = [
        "Bremer dan Gorst",
        "Whirrun de Blight",
        "Curdnen Craw"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(YourOfferSalaryCtaStyles.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
            containerSize: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HashAnchor/* HashAnchor */.v, {
                    name: "candidatos"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                    as: "h2",
                    size: "4xl",
                    align: "center",
                    editorial: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        i18nKey: "your-offer-salary.cta.title",
                        ns: "your-offer-salary"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                    direction: "column",
                    gap: "s",
                    children: data.stats.manfredites.map(function(candidate, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Card */.Zb, {
                            hideImage: true,
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                    href: "#yourOfferSalaryForm",
                                    size: "xs",
                                    variant: "ghost",
                                    schema: "positive",
                                    startIcon: pro_solid_svg_icons/* faThumbsUp */.u8Q,
                                    label: t("your-offer-salary.cta.button"),
                                    className: "like"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                    direction: "column",
                                    gap: "m",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(YourOfferSalaryCtaStyles.AvatarContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                    className: "blur",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Avatar */.qE, {
                                                        size: "2xl",
                                                        img: {
                                                            src: "/images/manfredita-".concat(index + 1, ".webp"),
                                                            alt: "".concat(manfrediteNames[index])
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                                    as: "h3",
                                                    size: "xl",
                                                    className: "blur",
                                                    children: manfrediteNames[index]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                            direction: "column",
                                            gap: "xl",
                                            children: [
                                                candidate.roles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                                    gap: "s",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: t("your-offer-salary.manfredite-info-card.roles")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* BadgeList */.k, {
                                                            stackWrapperProps: {
                                                                className: "badgeList"
                                                            },
                                                            items: candidate.roles.map(function(role) {
                                                                return {
                                                                    key: "role_".concat(role),
                                                                    label: role,
                                                                    variant: "ghost",
                                                                    schema: "neutral",
                                                                    size: "xs",
                                                                    bold: false,
                                                                    color: getRandomColorBySeed(role)
                                                                };
                                                            })
                                                        })
                                                    ]
                                                }),
                                                candidate.salaryRange && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                                    wrap: true,
                                                    gap: "s",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: t("your-offer-salary.manfredite-info-card.salary")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Badge */.Ct, {
                                                                label: candidate.salaryRange,
                                                                variant: "ghost",
                                                                schema: "neutral",
                                                                size: "xs",
                                                                color: getRandomColorBySeed(candidate.salaryRange)
                                                            })
                                                        })
                                                    ]
                                                }),
                                                candidate.experienceRange && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                                    wrap: true,
                                                    gap: "s",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: t("your-offer-salary.manfredite-info-card.experience")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Badge */.Ct, {
                                                                label: "".concat(candidate.experienceRange, " ").concat(t("your-offer-salary.manfredite-info-card.years")),
                                                                variant: "ghost",
                                                                schema: "neutral",
                                                                size: "xs",
                                                                color: getRandomColorBySeed(candidate.experienceRange)
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (candidate.techs.length > 0 || candidate.mainTechs.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                                    gap: "s",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: t("your-offer-salary.manfredite-info-card.techs")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                                            direction: "column",
                                                            gap: "m",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* BadgeList */.k, {
                                                                    stackWrapperProps: {
                                                                        className: "badgeList"
                                                                    },
                                                                    items: candidate.mainTechs.map(function(tech) {
                                                                        return {
                                                                            key: "mainTech_".concat(tech),
                                                                            icon: pro_solid_svg_icons/* faMedal */._su,
                                                                            label: tech,
                                                                            variant: "ghost",
                                                                            schema: "active",
                                                                            size: "xs",
                                                                            bold: true,
                                                                            color: getRandomColorBySeed(tech),
                                                                            tooltip: t("your-offer-salary.manfredite-info-card.main-tech")
                                                                        };
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* BadgeList */.k, {
                                                                    stackWrapperProps: {
                                                                        className: "badgeList"
                                                                    },
                                                                    items: candidate.techs.map(function(tech) {
                                                                        return {
                                                                            key: "tech_".concat(tech),
                                                                            label: tech,
                                                                            variant: "ghost",
                                                                            schema: "neutral",
                                                                            size: "xs",
                                                                            color: getRandomColorBySeed(tech)
                                                                        };
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, "candidate_".concat(index));
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ./components/form/FormCheckbox/index.ts + 1 modules
var FormCheckbox = __webpack_require__(74806);
// EXTERNAL MODULE: ./components/form/FormPhone/index.ts + 1 modules
var FormPhone = __webpack_require__(72109);
// EXTERNAL MODULE: ./components/form/FormText/FormText.tsx
var FormText = __webpack_require__(78712);
// EXTERNAL MODULE: ./components/form/FormTextarea/index.ts + 1 modules
var FormTextarea = __webpack_require__(13573);
// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
// EXTERNAL MODULE: ./features/portal/v2/contact/basic-info/ContactBasicInfo.constants.ts
var ContactBasicInfo_constants = __webpack_require__(18032);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../ui-common/dist/index.js + 26 modules
var ui_common_dist = __webpack_require__(49976);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs
var zod = __webpack_require__(33161);
// EXTERNAL MODULE: ./hooks/useToasts/index.ts
var useToasts = __webpack_require__(23793);
// EXTERNAL MODULE: ./services/service.deal.ts
var service_deal = __webpack_require__(75399);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ../utils/dist/esm/index.js + 3 modules
var dist_esm = __webpack_require__(74679);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ./features/public-your-offer-salary/form-contact/YourOfferSalaryFormContact.constants.ts


var I18N_PREFIX = "your-offer-salary:your-offer-salary";
var DEFAULT_TYPE_OPTION = {
    label: "SELECT_ONE",
    value: ""
};
var CompaniesFormFieldsSchema = lib.z.object({
    name: lib.z.string(),
    email: lib.z.string(),
    description: lib.z.string(),
    company: lib.z.string(),
    contactPhone: lib.z.string().optional(),
    terms: lib.z.boolean().optional(),
    isSubscribeToNewsletter: lib.z.boolean()
});
var CompaniesFormFieldsValidationSchema = CompaniesFormFieldsSchema.partial()// Name required
.refine(function(schema) {
    return !!schema.name;
}, {
    path: [
        "name"
    ],
    message: "".concat(I18N_PREFIX, ".form-contact.required-name")
})// Email required
.refine(function(schema) {
    return !!schema.email;
}, {
    path: [
        "email"
    ],
    message: "".concat(I18N_PREFIX, ".form-contact.required-email")
})// Email format
.refine(function(schema) {
    var ref;
    return (ref = schema.email) === null || ref === void 0 ? void 0 : ref.match(dist_esm/* EMAIL_REGEX */.CU);
}, {
    path: [
        "email"
    ],
    message: "".concat(I18N_PREFIX, ".form-contact.invalid-email")
})// Description required
.refine(function(schema) {
    return !!schema.description;
}, {
    path: [
        "description"
    ],
    message: "".concat(I18N_PREFIX, ".form-contact.required-description")
})// company required
.refine(function(schema) {
    return !!schema.company;
}, {
    path: [
        "company"
    ],
    message: "".concat(I18N_PREFIX, ".form-contact.required-company")
});
var FORM_FIELDS_DEFAULT_VALUES = {
    name: "",
    email: "",
    description: "",
    company: "",
    contactPhone: "",
    isSubscribeToNewsletter: false
};

// EXTERNAL MODULE: ../../node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(17473);
;// CONCATENATED MODULE: ./features/public-your-offer-salary/form-contact/YourOfferSalaryFormContact.hooks.ts















var useCompaniesForm = function() {
    var t = (0,useI18n/* useI18n */.Q)("your-offer-salary").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,useToasts/* useToasts */.e)(), addErrorToast = ref.addErrorToast, addSuccessToast = ref.addSuccessToast;
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var formMethods = (0,index_esm/* useForm */.cI)({
        defaultValues: FORM_FIELDS_DEFAULT_VALUES,
        resolver: (0,zod/* zodResolver */.F)(CompaniesFormFieldsValidationSchema)
    });
    var isTermsAccepted = !!formMethods.watch("terms");
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var recaptchaToken, ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!executeRecaptcha) {
                            console.error("Recaptcha not available");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            executeRecaptcha("your_offer_salary_form")
                        ];
                    case 1:
                        recaptchaToken = _state.sent();
                        return [
                            4,
                            service_deal/* ServiceDeal.create */.a.create((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                howDoYouKnowUs: "YOUR-OFFER-SALARY-LANDING",
                                source: "Manfred Web",
                                consultingOptions: [],
                                recaptchaToken: recaptchaToken
                            }))
                        ];
                    case 2:
                        _state.sent();
                        formMethods.reset(FORM_FIELDS_DEFAULT_VALUES);
                        addSuccessToast(t("your-offer-salary.form-contact.success"), t("your-offer-salary.form-contact.success_title"));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        ex = _state.sent();
                        ui_common_dist/* Logger.error */.Yd.error({
                            context: "CompaniesForm",
                            message: "There was an error while submitting the Companies form",
                            error: ex,
                            object: data
                        });
                        addErrorToast(t("your-offer-salary.form-contact.error"), t("your-offer-salary.form-contact.error_title"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addErrorToast,
        addSuccessToast,
        formMethods,
        executeRecaptcha,
        t
    ]);
    var onFormFieldFocus = (0,react.useCallback)(function() {
        service_event_tracking/* default.track */.Z.track({
            type: "Landing - Form Focused",
            properties: {
                objectName: "contacto-your-offer-salary-landing",
                url: window.location.href,
                urlParams: new URLSearchParams(window.location.search).toString()
            }
        });
    }, []);
    return {
        t: t,
        locale: locale,
        formMethods: formMethods,
        onSubmit: onSubmit,
        isTermsAccepted: isTermsAccepted,
        onFormFieldFocus: onFormFieldFocus
    };
};

;// CONCATENATED MODULE: ./features/public-your-offer-salary/form-contact/YourOfferSalaryFormContact.styled.tsx

function YourOfferSalaryFormContact_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 25px;\n  padding: 1.5rem;\n  margin: 2rem 1rem;\n  position: relative;\n  background: #b0b7e7;\n\n  .phoneNumber {\n  }\n\n  .half {\n    flex-basis: 50%;\n  }\n\n  form {\n    margin: auto;\n    max-width: 40rem;\n  }\n\n  a {\n    color: #097273;\n  }\n\n  @media (min-width: ",
        ") {\n    background: url('/images/companies-new/companies-new-hero-bg.svg') no-repeat\n      top center;\n    background-size: contain;\n    margin: 2rem 0 2rem 0;\n    border-radius: 0;\n    padding: 4rem 0;\n  }\n"
    ]);
    YourOfferSalaryFormContact_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function YourOfferSalaryFormContact_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h2 {\n    margin-top: 0;\n    font-size: ",
        ";\n    text-wrap: balance;\n    margin-bottom: 0rem;\n  }\n\n  p {\n    margin-bottom: 2rem;\n  }\n\n  @media (min-width: ",
        ") {\n    text-align: center;\n\n    h2 {\n      font-size: ",
        ";\n      margin-bottom: 0rem;\n    }\n\n    p {\n      text-align: center;\n    }\n  }\n"
    ]);
    YourOfferSalaryFormContact_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var YourOfferSalaryFormContact_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8211d15d-0"
})(YourOfferSalaryFormContact_styled_templateObject(), (0,theme/* screen */.sp)("lg"));
var Intro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8211d15d-1"
})(YourOfferSalaryFormContact_styled_templateObject1(), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl4"));
var Form = {
    Root: YourOfferSalaryFormContact_styled_Root,
    Intro: Intro
};

;// CONCATENATED MODULE: ./features/public-your-offer-salary/form-contact/YourOfferSalaryFormContact.tsx



















var YourOfferSalaryFormContact = function(param) {
    var data = param.data;
    var ref = useCompaniesForm(), t = ref.t, formMethods = ref.formMethods, locale = ref.locale, onSubmit = ref.onSubmit, isTermsAccepted = ref.isTermsAccepted, onFormFieldFocus = ref.onFormFieldFocus;
    var handleSubmit = formMethods.handleSubmit, isSubmitting = formMethods.formState.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
            containerSize: "xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HashAnchor/* HashAnchor */.v, {
                    name: "yourOfferSalaryForm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form.Intro, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                    editorial: true,
                                    as: "h2",
                                    size: "5xl",
                                    children: data.hasEnoughManfredites ? t("your-offer-salary.form-contact.title") : t("your-offer-salary.form-contact.title-no-data")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "your-offer-salary",
                                    i18nKey: data.hasEnoughManfredites ? "your-offer-salary.form-contact.desc" : "your-offer-salary.form-contact.desc-no-data"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                direction: "column",
                                gap: "3xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                className: "half",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                                    name: "name",
                                                    formGroup: {
                                                        label: t("your-offer-salary.form-contact.name")
                                                    },
                                                    input: {
                                                        placeholder: t("your-offer-salary.form-contact.name_placeholder"),
                                                        onFocus: onFormFieldFocus
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                className: "half",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                                    name: "company",
                                                    formGroup: {
                                                        label: t("your-offer-salary.form-contact.company")
                                                    },
                                                    input: {
                                                        placeholder: t("your-offer-salary.form-contact.company_placeholder"),
                                                        onFocus: onFormFieldFocus
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                className: "half",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                                    name: "email",
                                                    formGroup: {
                                                        label: t("your-offer-salary.form-contact.email")
                                                    },
                                                    input: {
                                                        placeholder: t("your-offer-salary.form-contact.email_placeholder"),
                                                        onFocus: onFormFieldFocus
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                className: "half phoneNumber",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormPhone/* FormPhone */.J, {
                                                    name: "contactPhone",
                                                    formGroup: {
                                                        label: t("your-offer-salary.form-contact.phone")
                                                    },
                                                    input: {
                                                        defaultCountry: ContactBasicInfo_constants/* PHONE_NUMBER_DEFAULT_COUNTRY */.r,
                                                        onFocus: onFormFieldFocus
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextarea/* FormTextarea */.B, {
                                        name: "description",
                                        formGroup: {
                                            label: t("your-offer-salary.form-contact.description")
                                        },
                                        input: {
                                            placeholder: t("your-offer-salary.form-contact.description_placeholder"),
                                            onFocus: onFormFieldFocus,
                                            rows: 3
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                        direction: "column",
                                        gap: "s",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCheckbox/* FormCheckbox */.z, {
                                                name: "terms",
                                                input: {
                                                    onFocus: onFormFieldFocus,
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                                        ns: "your-offer-salary",
                                                        i18nKey: "your-offer-salary.form-contact.terms",
                                                        components: {
                                                            privatePolicy: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.privacyPolicy */.uu.privacyPolicy, locale)
                                                            }),
                                                            terms: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.termsOfUse */.uu.termsOfUse, locale)
                                                            })
                                                        }
                                                    })
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCheckbox/* FormCheckbox */.z, {
                                                name: "isSubscribeToNewsletter",
                                                input: {
                                                    onFocus: onFormFieldFocus,
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                                        ns: "your-offer-salary",
                                                        i18nKey: "your-offer-salary.form-contact.newsletter",
                                                        components: {
                                                            newsletter: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://none.clickacm.com/show/qgJ2lZXPBBizIfJi3pmS/",
                                                                target: "_blank"
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                                            schema: "brand1",
                                            variant: "hard",
                                            label: t("your-offer-salary.form-contact.submit"),
                                            startIcon: free_solid_svg_icons/* faCheckCircle */.f8k,
                                            type: "submit",
                                            disabled: !isTermsAccepted,
                                            isLoading: isSubmitting,
                                            loadingText: t("your-offer-salary.form-contact.submit_in-progress")
                                        })
                                    })
                                ]
                            })
                        }))
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var form_contact_YourOfferSalaryFormContact = (YourOfferSalaryFormContact);

// EXTERNAL MODULE: ../api-common/dist/esm/index.js + 114 modules
var api_common_dist_esm = __webpack_require__(25465);
// EXTERNAL MODULE: ./components/form/FormCustomSelect/index.ts + 1 modules
var FormCustomSelect = __webpack_require__(33099);
// EXTERNAL MODULE: ./utils/api.ts
var api = __webpack_require__(3818);
// EXTERNAL MODULE: ./utils/fetch.ts
var fetch = __webpack_require__(89608);
// EXTERNAL MODULE: ./utils/headers.ts
var headers = __webpack_require__(93889);
;// CONCATENATED MODULE: ./model/manfredites-stats/model.manfredites-stats.ts

var ManfreditesManfrediteStatsSchema = lib.z.object({
    roles: lib.z.array(lib.z.string()),
    mainTechs: lib.z.array(lib.z.string()),
    techs: lib.z.array(lib.z.string()),
    experienceRange: lib.z.string(),
    salaryRange: lib.z.string(),
    wantsRemote: lib.z.boolean(),
    wantsHybrid: lib.z.boolean(),
    wantsFaceToFace: lib.z.boolean(),
    contractTypes: lib.z.array(lib.z["enum"]([
        "SELF_EMPLOYED",
        "EMPLOYED"
    ])).optional(),
    lastUpdateIsoString: lib.z.string().optional()
});
var ManfreditesStatsSchema = lib.z.object({
    hasEnoughManfredites: lib.z.boolean(),
    stats: lib.z.object({
        manfreditesCount: lib.z.number().optional(),
        salariesHeatMap: lib.z.object({
            salaryLabels: lib.z.array(lib.z.string()),
            experienceLabels: lib.z.array(lib.z.string()),
            heatMap: lib.z.array(lib.z.array(lib.z.number()))
        }),
        remoteOptionsPercentages: lib.z.object({
            remote: lib.z.number(),
            hybrid: lib.z.number(),
            onSite: lib.z.number()
        }),
        manfredites: lib.z.array(ManfreditesManfrediteStatsSchema)
    }).optional()
});

;// CONCATENATED MODULE: ./services/manfredites-stats/service.manfredite-stats.normalizer.ts

function normalizeToManfrediteStats(res) {
    if (!res.hasEnoughManfredites) {
        return {
            hasEnoughManfredites: false
        };
    }
    var data = {
        hasEnoughManfredites: res.hasEnoughManfredites,
        stats: res.stats ? {
            manfreditesCount: res.stats.manfreditesCount,
            salariesHeatMap: {
                salaryLabels: res.stats.salariesHeatMap.salaryLabels,
                experienceLabels: res.stats.salariesHeatMap.experienceLabels,
                heatMap: res.stats.salariesHeatMap.heatMap.map(function(row) {
                    return row.map(function(value) {
                        return value;
                    });
                })
            },
            remoteOptionsPercentages: {
                remote: res.stats.remoteOptionsPercentages.remote,
                hybrid: res.stats.remoteOptionsPercentages.hybrid,
                onSite: res.stats.remoteOptionsPercentages.onSite
            },
            manfredites: res.stats.manfredites.map(function(manfredite) {
                return {
                    roles: manfredite.roles,
                    mainTechs: manfredite.mainTechs,
                    techs: manfredite.techs,
                    experienceRange: manfredite.experienceRange,
                    salaryRange: manfredite.salaryRange,
                    wantsRemote: manfredite.wantsRemote,
                    wantsHybrid: manfredite.wantsHybrid,
                    wantsFaceToFace: manfredite.wantsFaceToFace,
                    contractTypes: manfredite.contractTypes,
                    lastUpdateIsoString: manfredite.lastUpdate ? new Date(manfredite.lastUpdate).toISOString() : undefined
                };
            })
        } : undefined
    };
    var result = ManfreditesStatsSchema.safeParse(data);
    if (!result.success) {
        return data;
    }
    return result.data;
}

;// CONCATENATED MODULE: ./services/manfredites-stats/service.manfredites-stats.ts






var ServiceManfreditesStats = {
    get: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
            var url, params, ref, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = (0,api/* getApiPathUrl */.P)("/v2/public/stats/manfredites");
                        params = new URLSearchParams();
                        params.append("roleId", req.roleId.toString());
                        params.append("withFluentEnglish", req.withFluentEnglish.toString());
                        if (req.techIds) {
                            params.append("techIds", req.techIds.join(","));
                        }
                        if (req.experienceId) {
                            params.append("experienceId", req.experienceId.toString() || "");
                        }
                        if (req.location) {
                            ;
                            params.append("location", ((ref = req.location) === null || ref === void 0 ? void 0 : ref.toString()) || "");
                        }
                        return [
                            4,
                            fetch/* get */.U2("".concat(url, "?").concat(params), (0,headers/* getAuthHeader */.E)())
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            normalizeToManfrediteStats(res)
                        ];
                }
            });
        });
        return function(req) {
            return _ref.apply(this, arguments);
        };
    }()
};

;// CONCATENATED MODULE: ./features/public-your-offer-salary/form/YourOfferSalaryForm.styles.ts

function YourOfferSalaryForm_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fbedff;\n  padding: 3rem 0rem 0 0rem;\n\n  .half {\n    flex-basis: 50%;\n  }\n\n  .quarter {\n    flex-basis: 33%;\n  }\n\n  .third {\n    flex-basis: 33%;\n  }\n"
    ]);
    YourOfferSalaryForm_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function YourOfferSalaryForm_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #dcb4e8;\n  padding: 2rem 0.5rem;\n  color: #52115e;\n  border-radius: 15px;\n  margin: 0 1rem 2rem 1rem;\n\n  @media (min-width: ",
        ") {\n    background: url('/images/companies-new/companies-new-hero-bg.svg') no-repeat\n      top center;\n    background-size: contain;\n    border-radius: 0;\n    padding: 3rem 8rem 5rem 8rem;\n  }\n\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n\n  > div:first-child p {\n    font-size: 1.25rem;\n  }\n"
    ]);
    YourOfferSalaryForm_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var YourOfferSalaryForm_styles_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6627999c-0"
})(YourOfferSalaryForm_styles_templateObject());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6627999c-1"
})(YourOfferSalaryForm_styles_templateObject1(), (0,theme/* screen */.sp)("xl"));
var YourOfferSalaryFormStyles = {
    Root: YourOfferSalaryForm_styles_Root,
    Content: Content
};

// EXTERNAL MODULE: ./model/index.ts + 29 modules
var model = __webpack_require__(41400);
;// CONCATENATED MODULE: ./features/public-your-offer-salary/form/YourOfferSalaryForm.types.ts


var YourOfferSalaryFormFieldsSchema = lib.z.object({
    role: model/* ListItemStringValueSchema */.uK,
    yearsOfExperience: model/* ListItemStringValueIdSchema */.Gr,
    techs: lib.z.array(model/* ListItemStringValueSchema */.uK).max(2, "your-offer-salary:your-offer-salary.messages.max-techs").min(1, "your-offer-salary:your-offer-salary.messages.min-techs"),
    withFluentEnglish: lib.z.boolean(),
    isRemote: lib.z.boolean(),
    location: model/* ListItemStringValueSchema.optional */.uK.optional()
});

;// CONCATENATED MODULE: ./features/public-your-offer-salary/form/YourOfferSalaryForm.tsx























var YourOfferSalaryForm = function(param) {
    var techs = param.techs, roles = param.roles, yearsOfExperience = param.yearsOfExperience, onSuccess = param.onSuccess;
    var t = (0,useI18n/* useI18n */.Q)("your-offer-salary").t;
    var addErrorToast = (0,useToasts/* useToasts */.e)().addErrorToast;
    var ref = (0,router.useRouter)(), query = ref.query, replace = ref.replace, locale = ref.locale;
    var submitRef = (0,react.useRef)(null);
    var locations = (0,react.useMemo)(function() {
        return api_common_dist_esm/* statsManfreditesQueryLocationValues.map */.khI.map(function(location) {
            return {
                label: location,
                value: location
            };
        });
    }, []);
    var formMethods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            techs: query.techs ? techs.filter(function(param) {
                var value = param.value;
                var ref;
                return (ref = query.techs) === null || ref === void 0 ? void 0 : ref.toString().split(",").includes(value);
            }) : [],
            withFluentEnglish: !!query.withFluentEnglish,
            isRemote: !!query.isRemote,
            location: query.location ? locations.find(function(param) {
                var value = param.value;
                var ref;
                return ((ref = query.location) === null || ref === void 0 ? void 0 : ref.toString()) === value;
            }) : undefined,
            role: query.role ? roles.find(function(param) {
                var value = param.value;
                var ref;
                return ((ref = query.role) === null || ref === void 0 ? void 0 : ref.toString()) === value;
            }) : undefined,
            yearsOfExperience: query.yearsOfExperience ? yearsOfExperience.find(function(param) {
                var value = param.value;
                var ref;
                return ((ref = query.yearsOfExperience) === null || ref === void 0 ? void 0 : ref.toString()) === value;
            }) : undefined
        },
        resolver: (0,zod/* zodResolver */.F)(YourOfferSalaryFormFieldsSchema)
    });
    var reset = formMethods.reset, getValues = formMethods.getValues;
    var onChangeUpdateQueryParams = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var shared, params, ref, role, techs, withFluentEnglish, isRemote, location, yearsOfExperience;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    shared = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                    params = new URLSearchParams();
                    ref = getValues(), role = ref.role, techs = ref.techs, withFluentEnglish = ref.withFluentEnglish, isRemote = ref.isRemote, location = ref.location, yearsOfExperience = ref.yearsOfExperience;
                    if (role) {
                        params.append("role", role.value);
                    }
                    if (techs && techs.length > 0) {
                        params.append("techs", techs.map(function(tech) {
                            return tech.value;
                        }).join(","));
                    }
                    if (withFluentEnglish) {
                        params.append("withFluentEnglish", String(withFluentEnglish));
                    }
                    if (isRemote) {
                        params.append("isRemote", String(isRemote));
                    }
                    if (location && !isRemote) {
                        params.append("location", location.value);
                    }
                    if (yearsOfExperience) {
                        params.append("yearsOfExperience", yearsOfExperience.value);
                    }
                    if (shared) {
                        params.append("shared", "true");
                    }
                    return [
                        4,
                        replace({
                            pathname: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.yourOfferSalary */.uu.yourOfferSalary, locale),
                            query: params.toString()
                        }, undefined, {
                            shallow: true
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        getValues,
        locale,
        replace
    ]);
    var isRemote = formMethods.watch("isRemote");
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var res, ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            ServiceManfreditesStats.get({
                                roleId: +data.role.value,
                                techIds: data.techs.map(function(tech) {
                                    return +tech.value;
                                }),
                                withFluentEnglish: data.withFluentEnglish,
                                experienceId: data.yearsOfExperience.id,
                                location: !data.isRemote && data.location ? data.location.value : undefined
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        onSuccess(res, data.yearsOfExperience.value);
                        onChangeUpdateQueryParams(true);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        ex = _state.sent();
                        ui_common_dist/* Logger.error */.Yd.error({
                            context: "YourOfferSalaryForm",
                            message: "Error submitting form",
                            error: ex
                        });
                        addErrorToast(t("your-offer-salary.messages.submit-error", {
                            error: (0,ui_common_dist/* getErrorMessage */.e$)(ex)
                        }), t("your-offer-salary.messages.submit-error_title"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSuccess,
        onChangeUpdateQueryParams,
        addErrorToast,
        t
    ]);
    (0,react.useEffect)(function() {
        reset({
            techs: query.techs ? techs.filter(function(param) {
                var value = param.value;
                var ref;
                return (ref = query.techs) === null || ref === void 0 ? void 0 : ref.toString().split(",").includes(value);
            }) : [],
            withFluentEnglish: !!query.withFluentEnglish,
            isRemote: !!query.isRemote,
            location: query.location ? locations.find(function(param) {
                var value = param.value;
                var ref;
                return ((ref = query.location) === null || ref === void 0 ? void 0 : ref.toString()) === value;
            }) : undefined,
            role: query.role ? roles.find(function(param) {
                var value = param.value;
                var ref;
                return ((ref = query.role) === null || ref === void 0 ? void 0 : ref.toString()) === value;
            }) : undefined,
            yearsOfExperience: query.yearsOfExperience ? yearsOfExperience.find(function(param) {
                var value = param.value;
                var ref;
                return ((ref = query.yearsOfExperience) === null || ref === void 0 ? void 0 : ref.toString()) === value;
            }) : undefined
        });
    }, [
        locations,
        query,
        roles,
        techs,
        yearsOfExperience
    ]);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            if (submitRef.current && query.shared) {
                submitRef.current.click();
            }
        }, 200);
    }, [
        query.shared
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(YourOfferSalaryFormStyles.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page_styled/* PageContentContainer */.R, {
            containerSize: "lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YourOfferSalaryFormStyles.Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                    as: "h2",
                                    size: "4xl",
                                    editorial: true,
                                    align: "center",
                                    children: t("your-offer-salary.form-title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "your-offer-salary",
                                    i18nKey: "your-offer-salary.form-desc"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            onSubmit: formMethods.handleSubmit(onSubmit),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                className: "third",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCustomSelect/* FormCustomSelect */.t, {
                                                    name: "role",
                                                    options: roles,
                                                    input: {
                                                        isSmall: true,
                                                        placeholder: t("your-offer-salary.fields.role_placeholder"),
                                                        onChange: onChangeUpdateQueryParams
                                                    },
                                                    formGroup: {
                                                        label: t("your-offer-salary.fields.role")
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                className: "third",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCustomSelect/* FormCustomSelect */.t, {
                                                    name: "techs",
                                                    options: techs,
                                                    input: {
                                                        isSmall: true,
                                                        max: 2,
                                                        isMulti: true,
                                                        placeholder: t("your-offer-salary.fields.techs_placeholder"),
                                                        onChange: onChangeUpdateQueryParams
                                                    },
                                                    formGroup: {
                                                        label: t("your-offer-salary.fields.techs")
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                className: "third",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCustomSelect/* FormCustomSelect */.t, {
                                                    name: "yearsOfExperience",
                                                    options: yearsOfExperience,
                                                    input: {
                                                        isSmall: true,
                                                        placeholder: t("your-offer-salary.fields.years-of-experience_placeholder"),
                                                        onChange: onChangeUpdateQueryParams
                                                    },
                                                    formGroup: {
                                                        label: t("your-offer-salary.fields.years-of-experience")
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                        alignment: "flex-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                className: "half",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                                    direction: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCheckbox/* FormCheckbox */.z, {
                                                            name: "withFluentEnglish",
                                                            input: {
                                                                label: t("your-offer-salary.fields.with-fluent-english"),
                                                                onChange: onChangeUpdateQueryParams
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCheckbox/* FormCheckbox */.z, {
                                                            name: "isRemote",
                                                            input: {
                                                                label: t("your-offer-salary.fields.remote"),
                                                                onChange: onChangeUpdateQueryParams
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            !isRemote && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                className: "half",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCustomSelect/* FormCustomSelect */.t, {
                                                    name: "location",
                                                    options: locations,
                                                    formGroup: {
                                                        label: t("your-offer-salary.fields.location")
                                                    },
                                                    input: {
                                                        isSmall: true,
                                                        placeholder: t("your-offer-salary.fields.location_placeholder"),
                                                        onChange: onChangeUpdateQueryParams
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                                        contentAlign: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                                            type: "submit",
                                            schema: "brand1",
                                            label: formMethods.formState.isSubmitting ? t("your-offer-salary.actions.submitting") : t("your-offer-salary.actions.submit"),
                                            disabled: !formMethods.formState.isValid || formMethods.formState.isSubmitting,
                                            startIcon: pro_solid_svg_icons/* faCalculator */.lTt,
                                            size: "xs",
                                            ref: submitRef
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }))
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/chroma-js/index.js + 101 modules
var chroma_js = __webpack_require__(96016);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./features/public-your-offer-salary/results/YourOfferSalaryResults.styles.ts

function YourOfferSalaryResults_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #d7edf1;\n  padding-top: 4rem;\n\n  h2 {\n    margin-bottom: 1rem;\n  }\n\n  figure {\n    margin: 0 auto 2rem auto;\n    max-width: 85%;\n  }\n\n  .no-results {\n    padding: 4rem 0 6rem 0;\n\n    svg {\n      color: #55c6be;\n    }\n  }\n\n  legend > span > span {\n    font-size: 0.875rem;\n\n    @media (min-width: ",
        ") {\n      font-size: 1rem;\n    }\n  }\n\n  fieldset > div {\n    padding: 0.25rem;\n\n    @media (min-width: ",
        ") {\n      padding: 0.75rem;\n    }\n  }\n\n  table {\n    margin: 0 auto;\n    font-size: 0.65rem;\n    cell-spacing: 0;\n    border-collapse: collapse;\n    width: 100%;\n\n    @media (min-width: ",
        ") {\n      font-size: 1rem;\n    }\n\n    th,\n    td {\n      padding: 0.25rem;\n    }\n\n    th {\n      text-align: center;\n      border-bottom: 1px solid #eee;\n    }\n\n    tr td:first-child {\n      text-align: right;\n    }\n\n    td {\n      padding: 0.15rem;\n\n      @media (min-width: ",
        ") {\n        padding: 0.25rem;\n      }\n\n      &.max > div {\n        border-color: rgba(0, 0, 0, 0.4);\n      }\n\n      > div {\n        border: 3px solid transparent;\n        background: #f8f8f8;\n        font-variant-numeric: tabular-nums;\n        border-radius: 5px;\n        padding: 0.5rem 0.75rem;\n      }\n\n      &.right {\n        text-align: center;\n      }\n    }\n\n    tfoot td {\n      border-top: 1px solid #eee;\n      padding-top: 0.5rem;\n      font-size: 0.875rem;\n      color: #333;\n      font-style: italic;\n    }\n  }\n"
    ]);
    YourOfferSalaryResults_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function YourOfferSalaryResults_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #55c6be;\n  border-radius: 15px;\n  padding: 2rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin: 0 1rem 2rem 1rem;\n\n  @media (min-width: ",
        ") {\n    background: url('/images/home-v2/home-v2-hero-bg.svg') no-repeat top center;\n    background-size: contain;\n    border-radius: 0;\n    padding: 7rem 4rem 0 4rem;\n  }\n\n  h2,\n  h3 {\n    color: #fff;\n  }\n\n  .fieldset-wrapper {\n    margin: 0;\n\n    @media (min-width: ",
        ") {\n      margin: 0 4rem;\n    }\n  }\n\n  .number {\n    background: url('/images/contact/contact-form-bg.svg') no-repeat top center;\n    background-size: contain;\n    padding: 1.5rem 1.5rem;\n    text-align: center;\n    font-size: 2.5rem;\n    line-height: 0;\n    font-weight: 800;\n\n    strong {\n      font-size: 1rem;\n      font-weight: 800;\n      color: rgba(0, 0, 0, 0.6);\n      text-transform: uppercase;\n    }\n\n    p {\n      font-family: 'Big Shoulders Display', sans-serif;\n    }\n  }\n"
    ]);
    YourOfferSalaryResults_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function YourOfferSalaryResults_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: hidden;\n  overflow-x: hidden;\n\n  @media (max-width: ",
        ") {\n    overflow-x: auto;\n  }\n\n  .recharts-surface {\n    max-height: 100%;\n    margin-top: 3px;\n  }\n\n  .recharts-cartesian-axis-line {\n    stroke: ",
        ";\n  }\n\n  .recharts-text {\n    fill: ",
        ";\n    font-size: ",
        ";\n    text-transform: uppercase;\n    font-weight: ",
        ";\n  }\n\n  .recharts-label {\n    text-transform: inherit;\n    fill: ",
        ";\n  }\n\n  .recharts-legend-wrapper {\n    right: -",
        " !important;\n  }\n\n  .recharts-legend-item {\n    margin-bottom: ",
        ";\n    display: flex !important;\n    align-items: center;\n  }\n\n  .recharts-legend-item-text {\n    color: ",
        " !important;\n    font-size: ",
        ";\n    text-align: left;\n  }\n\n  .recharts-default-tooltip {\n    background-color: ",
        " !important;\n    border: 0 !important;\n    border-radius: ",
        ";\n    padding: ",
        " !important;\n    font-size: ",
        ";\n    color: ",
        ";\n    font-weight: ",
        ";\n    position: relative;\n\n    &::before {\n      content: '';\n      width: 0;\n      height: 0;\n      position: absolute;\n    }\n  }\n\n  .recharts-tooltip-wrapper-bottom .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid ",
        ";\n    top: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-top .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid ",
        ";\n    bottom: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-left .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 6px solid ",
        ";\n    right: -5px;\n    left: unset;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-wrapper-right .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid ",
        ";\n    left: -5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-item {\n    padding: 0 !important;\n    color: inherit !important;\n  }\n\n  .recharts-tooltip-item-name {\n    font-weight: ",
        ";\n  }\n\n  .recharts-label {\n    fill: #fff;\n  }\n"
    ]);
    YourOfferSalaryResults_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var YourOfferSalaryResults_styles_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-358140a2-0"
})(YourOfferSalaryResults_styles_templateObject(), (0,theme/* screen */.sp)("xl"), (0,theme/* screen */.sp)("xl"), (0,theme/* screen */.sp)("xl"), (0,theme/* screen */.sp)("xl"));
var Salaries = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-358140a2-1"
})(YourOfferSalaryResults_styles_templateObject1(), (0,theme/* screen */.sp)("xl"), (0,theme/* screen */.sp)("xl"));
var Chart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-358140a2-2"
})(YourOfferSalaryResults_styles_templateObject2(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* radius */.q0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* fontWeight */.Ue)("extraBold"));
var YourOfferSalaryResultsStyles = {
    Root: YourOfferSalaryResults_styles_Root,
    Salaries: Salaries,
    Chart: Chart
};

;// CONCATENATED MODULE: ./features/public-your-offer-salary/results/YourOfferSalaryResults.tsx















var ShareModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1539).then(__webpack_require__.bind(__webpack_require__, 9011));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9011)
            ];
        }
    },
    ssr: false
});
var YourOfferSalaryResults = function(param) {
    var data = param.data, experienceRange = param.experienceRange;
    var _Math, _Math1, _Math2;
    var getHeatMapTotalPerRow = function getHeatMapTotalPerRow(rowIndex) {
        return heatMap.map(function(row) {
            return row[rowIndex];
        }).reduce(function(acc, value) {
            return acc + value;
        }, 0);
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,useI18n/* useI18n */.Q)("your-offer-salary").t;
    var ref8 = (0,router.useRouter)(), locale = ref8.locale, query = ref8.query;
    var RESULT_THRESHOLD = 5;
    var ref9 = (0,react.useState)(false), isShareModalOpened = ref9[0], setIsShareModalOpened = ref9[1];
    var experiences = ((ref = data.stats) === null || ref === void 0 ? void 0 : ref.salariesHeatMap.experienceLabels.filter(function(value) {
        return value !== "Unspecified";
    })) || [];
    var salaries = ((ref1 = data.stats) === null || ref1 === void 0 ? void 0 : ref1.salariesHeatMap.salaryLabels) || [];
    var heatMap = ((ref2 = data.stats) === null || ref2 === void 0 ? void 0 : ref2.salariesHeatMap.heatMap) || [];
    var min = (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(heatMap.flatMap(function(row) {
        return row;
    })));
    var max = (_Math1 = Math).max.apply(_Math1, (0,_to_consumable_array/* default */.Z)(heatMap.flatMap(function(row) {
        return row;
    })));
    var remoteOptions = [
        ((ref3 = data.stats) === null || ref3 === void 0 ? void 0 : ref3.remoteOptionsPercentages.onSite) || 0,
        ((ref4 = data.stats) === null || ref4 === void 0 ? void 0 : ref4.remoteOptionsPercentages.hybrid) || 0,
        ((ref5 = data.stats) === null || ref5 === void 0 ? void 0 : ref5.remoteOptionsPercentages.remote) || 0
    ];
    var totalUnspecified = getHeatMapTotalPerRow(0);
    var totalJunior = getHeatMapTotalPerRow(1);
    var totalMid = getHeatMapTotalPerRow(2);
    var totalSenior = getHeatMapTotalPerRow(3);
    var totalPrincipal = getHeatMapTotalPerRow(4);
    var scale = chroma_js/* default.scale */.ZP.scale([
        "#efefef",
        "#27a39a"
    ]).domain([
        min,
        max
    ]);
    var expLabels = {
        Unspecified: t("your-offer-salary.result.experiences-undefined"),
        "<2": t("your-offer-salary.result.experiences-less-2"),
        "2-5": t("your-offer-salary.result.experiences-2-5"),
        "5-10": t("your-offer-salary.result.experiences-5-10"),
        ">10": t("your-offer-salary.result.experiences-more-10")
    };
    // Get max salary range for each experience level
    var getMaxSalaryRangeForExperience = function() {
        var maxSalaryByExperience = {};
        experiences.forEach(function(exp, expIndex) {
            var colIndex = expIndex + 1; // Skip the 'Unspecified' column (index 0)
            var maxValue = 0;
            var maxSalaryIndex = 0;
            heatMap.forEach(function(row, rowIndex) {
                var value = row[colIndex];
                if (value > maxValue) {
                    maxValue = value;
                    maxSalaryIndex = rowIndex;
                }
            });
            maxSalaryByExperience[exp] = {
                value: maxValue,
                salary: salaries[maxSalaryIndex]
            };
        });
        return maxSalaryByExperience;
    };
    var maxSalaryRangeByExperience = getMaxSalaryRangeForExperience();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(YourOfferSalaryResultsStyles.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page_styled/* PageContentContainer */.R, {
            containerSize: "lg",
            children: !data.hasEnoughManfredites ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                direction: "column",
                contentAlign: "center",
                className: "no-results",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                        icon: pro_light_svg_icons/* faFaceSurprise */.IeB,
                        size: "7xl"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                            as: "h2",
                            size: "4xl",
                            editorial: true,
                            align: "center",
                            children: t("your-offer-salary.result.no-results")
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isShareModalOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal, {
                        isOpened: isShareModalOpened,
                        close: function() {
                            return setIsShareModalOpened(false);
                        },
                        url: "".concat(window.location.origin, "/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.yourOfferSalary */.uu.yourOfferSalary, locale), "?").concat(new URLSearchParams(Object.entries(query).reduce(function(acc, param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                            if (Array.isArray(value)) {
                                acc[key] = value.join(",");
                            } else if (value !== undefined) {
                                acc[key] = value;
                            }
                            return acc;
                        }, {}))),
                        emailSubject: t("your-offer-salary.result.share-modal.email-subject"),
                        twitterMessage: t("your-offer-salary.result.share-modal.text"),
                        telegramMessage: t("your-offer-salary.result.share-modal.text"),
                        whatsappMessage: t("your-offer-salary.result.share-modal.text"),
                        emailMessage: t("your-offer-salary.result.share-modal.email-text")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                        direction: "column",
                        gap: "l",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(YourOfferSalaryResultsStyles.Salaries, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                                    children: [
                                        ((ref6 = data.stats) === null || ref6 === void 0 ? void 0 : ref6.manfreditesCount) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                            as: "h2",
                                            size: "4xl",
                                            align: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                i18nKey: "your-offer-salary.result.count",
                                                ns: "your-offer-salary",
                                                values: {
                                                    count: (ref7 = data.stats) === null || ref7 === void 0 ? void 0 : ref7.manfreditesCount.toLocaleString(locale)
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Notification */.P_, {
                                            type: "warning",
                                            message: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                i18nKey: "your-offer-salary.result.not-enough",
                                                ns: "your-offer-salary"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                            direction: "row",
                                            gap: "3xl",
                                            contentAlign: "center",
                                            children: [
                                                totalJunior > RESULT_THRESHOLD && experienceRange === "<2" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "number",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: expLabels["<2"]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: maxSalaryRangeByExperience["<2"].salary
                                                        })
                                                    ]
                                                }),
                                                totalMid > RESULT_THRESHOLD && experienceRange === "2-5" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "number",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: expLabels["2-5"]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: maxSalaryRangeByExperience["2-5"].salary
                                                        })
                                                    ]
                                                }),
                                                totalSenior > RESULT_THRESHOLD && experienceRange === "5-10" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "number",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: expLabels["5-10"]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: maxSalaryRangeByExperience["5-10"].salary
                                                        })
                                                    ]
                                                }),
                                                totalPrincipal > RESULT_THRESHOLD && experienceRange === ">10" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "number",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: expLabels[">10"]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: maxSalaryRangeByExperience[">10"].salary
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                    contentAlign: "center",
                                    alignment: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                                                schema: "brand1",
                                                variant: "hard",
                                                type: "button",
                                                size: "xs",
                                                startIcon: pro_light_svg_icons/* faShareSquare */.tFX,
                                                onClick: function() {
                                                    return setIsShareModalOpened(true);
                                                },
                                                label: t("your-offer-salary.result.share")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                                href: "#candidatos",
                                                schema: "brand1",
                                                variant: "ghost",
                                                type: "button",
                                                size: "xs",
                                                startIcon: pro_solid_svg_icons/* faUsers */.FVb,
                                                label: t("your-offer-salary.result.candidates")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fieldset */.pg, {
                                    legend: t("your-offer-salary.result.heatmap-title"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            style: {
                                                                width: "7rem"
                                                            }
                                                        }),
                                                        experiences.map(function(experience) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                children: expLabels[experience]
                                                            }, experience);
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                children: [
                                                    heatMap.map(function(row, rowIndex) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: salaries[rowIndex]
                                                                    })
                                                                }),
                                                                row.map(function(value, colIndex) {
                                                                    return colIndex > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "right ".concat((_Math2 = Math).max.apply(_Math2, (0,_to_consumable_array/* default */.Z)(heatMap.map(function(row) {
                                                                            return row[colIndex];
                                                                        }))) === value && value > 0 ? "max" : ""),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            style: {
                                                                                backgroundColor: scale(value).hex()
                                                                            },
                                                                            children: [
                                                                                value.toLocaleString(locale),
                                                                                "%"
                                                                            ]
                                                                        })
                                                                    }, colIndex);
                                                                })
                                                            ]
                                                        }, rowIndex);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    children: "TOTAL"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "right",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                        children: [
                                                                            totalJunior.toLocaleString(locale),
                                                                            "%"
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "right",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                        children: [
                                                                            totalMid.toLocaleString(locale),
                                                                            "%"
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "right",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                        children: [
                                                                            totalSenior.toLocaleString(locale),
                                                                            "%"
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "right",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                        children: [
                                                                            totalPrincipal.toLocaleString(locale),
                                                                            "%"
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            totalUnspecified > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("tfoot", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        colSpan: 5,
                                                        children: t("your-offer-salary.result.heatmap-undefined", {
                                                            value: "".concat(totalUnspecified.toLocaleString(locale, {
                                                                minimumFractionDigits: 1
                                                            }), "%")
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./features/public-your-offer-salary/YourOfferSalaryPage.tsx












var YourOfferSalaryPage = function(param) {
    var roles = param.roles, techs = param.techs, yearsOfExperience = param.yearsOfExperience;
    var t = (0,useI18n/* useI18n */.Q)("your-offer-salary").t;
    var query = (0,router.useRouter)().query;
    var resultsRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), result = ref[0], setResult = ref[1];
    var ref1 = (0,react.useState)(null), experienceRange = ref1[0], setExperienceRange = ref1[1];
    var onSuccess = function(data, experienceRange) {
        setExperienceRange(experienceRange);
        setResult(data);
        if (resultsRef.current) {
            resultsRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    };
    (0,react.useEffect)(function() {
        if (resultsRef.current && !!result) {
            resultsRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }, [
        query.shared,
        result
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("your-offer-salary.page_title"),
                desc: t("your-offer-salary.page_description"),
                url: app_urls/* APP_URLS.companies */.uu.companies,
                imgUrl: "".concat((0,paths/* getPublicPath */.A)("/images/cards/card_your_offer_salary.webp"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
                hasScrollTop: true,
                pageVariant: "your_salary_offer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YourOfferSalaryForm, {
                        roles: roles,
                        techs: techs,
                        yearsOfExperience: yearsOfExperience,
                        onSuccess: onSuccess
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: resultsRef,
                        children: [
                            !!result && experienceRange && /*#__PURE__*/ (0,jsx_runtime.jsx)(YourOfferSalaryResults, {
                                data: result,
                                experienceRange: experienceRange
                            }),
                            !!result && /*#__PURE__*/ (0,jsx_runtime.jsx)(YourOfferSalaryCta, {
                                data: result
                            }),
                            !!result && /*#__PURE__*/ (0,jsx_runtime.jsx)(form_contact_YourOfferSalaryFormContact, {
                                data: result
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/your-offer-salary.tsx

var __N_SSG = true;
/* harmony default export */ var your_offer_salary = (YourOfferSalaryPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,3955,1534,6048,625,4882,6248,9774,2888,179], function() { return __webpack_exec__(33479); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);